import { ACCOUNT_TYPE } from 'adv-lib/src/v2/interface/common'
import {
  ATTACHMENT_TYPE,
  DEVICE_TYPE,
  PAY_STATE,
  PG_TYPE,
  RISK_TELEGRAM_ALARM_ACTION_TYPE,
  TIMELINE_SOCCER_DISCIPLINARY_TYPE,
} from 'adv-lib/src/v2/constants/common'
import { ACCOUNT_ROLE, JOB_TYPE, LS_SPORT_ID, SPORT_ID } from 'adv-protocol/src/GameCommon'
import { RISK_TELEGRAM_ALARM_REACT_TYPE, RISK_TELEGRAM_ALARM_TYPE } from 'adv-lib/src/v2/constants/admin/common'
import { CHEER_FOR_TEAM_CONTENTS_TYPE } from 'adv-lib/src/v2/constants/cheer'

export default class ConvertUtils {

  static accountTypeToRiskTelegramAlarmActionType(accountType: ACCOUNT_TYPE): RISK_TELEGRAM_ALARM_ACTION_TYPE {
    switch (accountType) {
      case ACCOUNT_TYPE.GOOGLE:
        return RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_GOOGLE
      case ACCOUNT_TYPE.NAVER:
        return RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_NAVER
      case ACCOUNT_TYPE.APPLE:
        return RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_APPLE
      case ACCOUNT_TYPE.LOCAL:
        return RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_LOCAL
      default:
        return null
    }
  }

  static riskTelegramAlarmReactTypeToText(type: RISK_TELEGRAM_ALARM_REACT_TYPE, defaultValue = ''): string {
    switch (type) {
      case RISK_TELEGRAM_ALARM_REACT_TYPE.MONITORING:
        return '모니터링'
      case RISK_TELEGRAM_ALARM_REACT_TYPE.BLOCK:
        return '제재'
      case RISK_TELEGRAM_ALARM_REACT_TYPE.ETC:
        return '기타'
      case RISK_TELEGRAM_ALARM_REACT_TYPE.CARE:
        return '케어'
      default:
        return defaultValue
    }
  }

  static riskTelegramAlarmActionTypeToText(type: RISK_TELEGRAM_ALARM_ACTION_TYPE, defaultValue = ''): string {
    switch (type) {
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.V2_LOGIN:
        return '로그인(인게임)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.BETTING:
        return '베팅'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.PAY:
        return '결제'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.V1_LOGIN:
        return '로그인(PC클라)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.HOME_LOGIN:
        return '로그인(홈페이지)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_LOCAL:
        return '회원가입(멤버십)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_NAVER:
        return '회원가입(네이버)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_GOOGLE:
        return '회원가입(구글)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.REGISTER_APPLE:
        return '회원가입(애플)'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.SEND_MESSAGE:
        return '메시지 발송'
      case RISK_TELEGRAM_ALARM_ACTION_TYPE.V2_SOCKET:
        return '로그인(소켓연결)'
      default:
        return defaultValue
    }
  }

  static riskTelegramAlarmTypeToText(type: RISK_TELEGRAM_ALARM_TYPE, defaultValue = ''): string {
    switch (type) {
      case RISK_TELEGRAM_ALARM_TYPE.IP:
        return '아이피'
      case RISK_TELEGRAM_ALARM_TYPE.MESSAGE:
        return '메시지'
      case RISK_TELEGRAM_ALARM_TYPE.NICK:
        return '닉네임'
      case RISK_TELEGRAM_ALARM_TYPE.PHONE:
        return '휴대폰번호'
      default:
        return defaultValue
    }
  }

  static payStateToText(payState: PAY_STATE, defaultValue = '-'): string {
    switch (payState) {
      case PAY_STATE.PENDING:
        return '입금대기'
      case PAY_STATE.COMPLETE:
        return '정상'
      case PAY_STATE.CANCELED:
        return '환불'
      case PAY_STATE.PG_CANCELED:
        return '환불 (PG사)'
      default:
        return defaultValue
    }
  }

  static pgTypeToText(pgType: PG_TYPE, defaultValue = '-'): string {
    switch (pgType) {
      case PG_TYPE.VA:
        return '가상계좌'
      case PG_TYPE.MC:
        return '휴대폰'
      case PG_TYPE.CN:
        return '신용카드'
      case PG_TYPE.GM:
        return '컬쳐랜드'
      case PG_TYPE.GG:
        return '스마트문상'
      case PG_TYPE.GC:
        return '도서문화상품권'
      case PG_TYPE.TM:
        return '모바일티머니'
      case PG_TYPE.RA:
        return '계좌이체'
      case PG_TYPE.TC:
        return '캐시비'
      case PG_TYPE.HM:
        return '해피머니'
      case PG_TYPE.FC:
        return '퍼니카드'
      default:
        return defaultValue
    }
  }

  static accountRoleToText(role: ACCOUNT_ROLE, defaultValue = '-'): string {
    switch (role) {
      case ACCOUNT_ROLE.NORMAL:
        return '일반'
      case ACCOUNT_ROLE.OPERATOR:
        return '운영자'
      case ACCOUNT_ROLE.DEVELOPER:
        return '개발자'
      case ACCOUNT_ROLE.DUMMY:
        return '더미'
      case ACCOUNT_ROLE.PREPARED_ODDSMAKER:
        return '예비 오즈'
      default:
        return defaultValue
    }
  }

  static deviceTypeToText(payDevice: DEVICE_TYPE, defaultValue = '-'): string {
    switch (payDevice) {
      case DEVICE_TYPE.PC:
        return 'PC'
      case DEVICE_TYPE.MOBILE:
        return '모바일'
      default:
        return defaultValue
    }
  }

  static betRadarSportIdToLsportsSportId(sportId: SPORT_ID, defaultValue?: LS_SPORT_ID): LS_SPORT_ID {
    switch (sportId) {
      case SPORT_ID.SOCCER:
        return LS_SPORT_ID.FOOTBALL
      case SPORT_ID.BASKETBALL:
        return LS_SPORT_ID.BASKETBALL
      case SPORT_ID.BASEBALL:
        return LS_SPORT_ID.BASEBALL
      case SPORT_ID.VOLLEYBALL:
        return LS_SPORT_ID.VOLLEYBALL
      case SPORT_ID.ICE_HOCKEY:
        return LS_SPORT_ID.ICE_HOCKEY
      default:
        return (defaultValue ?? sportId) as LS_SPORT_ID
    }
  }

  static accountTypeToText(accountType: ACCOUNT_TYPE, defaultValue = '-'): string {
    switch (accountType) {
      case ACCOUNT_TYPE.LOCAL:
        return '멤버쉽'
      case ACCOUNT_TYPE.GOOGLE:
        return '구글'
      case ACCOUNT_TYPE.NAVER:
        return '네이버'
      case ACCOUNT_TYPE.APPLE:
        return '애플'
      case ACCOUNT_TYPE.KAKAO:
        return '카카오'
      default:
        return defaultValue
    }
  }

  /**
   * makeOrderID 함수를 이용하여 orderId 를 만들때 벳레이더의 스포츠 아이디 8비트의 정수를 기준으로 만들고 있었으나
   * lsports 의 경기 아이디는 32비트 정수까지 사용해야 함으로 orderId 를 만들때만 벳레이더의 스포츠아이디를 사용하도록 하여
   * orderId 의 순서가 맞지 않는 현상을 해결한다.
   *
   * lsports 의 스포츠 아이디를 사용할 경우 경기 시간에 맞는 orderId 가 생성되지 않는다.
   * 빠른 경기시간 7:00 인데도 늦은 경기시간 8:00 보다 늦게 목록에 나오는 경우가 있음.
   *
   * @param lsSportId
   */
  static lsSportIdToBetRadarSportId(lsSportId: LS_SPORT_ID): number {
    const UNKNOWN = 250
    switch (lsSportId) {
      case LS_SPORT_ID.UNKNOWN:
        return UNKNOWN
      case LS_SPORT_ID.BEACH_VOLLEYBALL:
        return SPORT_ID.BEACH_VOLLEY
      case LS_SPORT_ID.TABLE_TENNIS:
        return SPORT_ID.TABLE_TENNIS
      case LS_SPORT_ID.FUTSAL:
        return SPORT_ID.FUTSAL
      case LS_SPORT_ID.HORSE_RACING:
        return SPORT_ID.HORSE_RACING
      case LS_SPORT_ID.GOLF:
        return SPORT_ID.GOLF
      case LS_SPORT_ID.E_GAMES:
        return SPORT_ID.E_SPORT
      case LS_SPORT_ID.GREYHOUNDS:
        return SPORT_ID.GREYHOUND
      case LS_SPORT_ID.TROTTING:
        return SPORT_ID.TROTTING
      case LS_SPORT_ID.SPEEDWAY:
        return SPORT_ID.SPEEDWAY
      case LS_SPORT_ID.FOOTBALL:
        return SPORT_ID.SOCCER
      case LS_SPORT_ID.BASKETBALL:
        return SPORT_ID.BASKETBALL
      case LS_SPORT_ID.MOTOGP:
        return SPORT_ID.MOTO_GP
      case LS_SPORT_ID.CHESS:
        return SPORT_ID.CHESS
      case LS_SPORT_ID.VOLLEYBALL:
        return SPORT_ID.VOLLEYBALL
      case LS_SPORT_ID.ICE_HOCKEY:
        return SPORT_ID.ICE_HOCKEY
      case LS_SPORT_ID.CRICKET:
        return SPORT_ID.CRICKET
      case LS_SPORT_ID.EQUINE_SPORTS:
        return SPORT_ID.HORSEBALL
      case LS_SPORT_ID.AUSTRALIAN_RULES:
        return SPORT_ID.AUSSIE_RULES
      case LS_SPORT_ID.BADMINTON:
        return SPORT_ID.BADMINTON
      case LS_SPORT_ID.FORMULA_1:
        return SPORT_ID.FORMULA_1
      case LS_SPORT_ID.NASCAR:
        return SPORT_ID.NASCAR_CUP_SERIES
      case LS_SPORT_ID.HOCKEY:
        return SPORT_ID.FIELD_HOCKEY
      case LS_SPORT_ID.SUPERCARS:
        return UNKNOWN // 벳레이더에 경기 없음
      case LS_SPORT_ID.NETBALL:
        return SPORT_ID.NETBALL
      case LS_SPORT_ID.SURFING:
        return SPORT_ID.SURFING
      case LS_SPORT_ID.CYCLING:
        return SPORT_ID.CYCLING
      case LS_SPORT_ID.GAELIC_SPORTS:
        return SPORT_ID.GAELIC_SPORTS
      case LS_SPORT_ID.BIATHLON:
        return SPORT_ID.BIATHLON
      case LS_SPORT_ID.MOTORBIKES:
        return SPORT_ID.MOTORCYCLE_RACING
      case LS_SPORT_ID.ATHLETICS:
        return SPORT_ID.ATHLETICS
      case LS_SPORT_ID.SQUASH:
        return SPORT_ID.SQUASH
      case LS_SPORT_ID.BASKETBALL_3X3:
        return SPORT_ID.BASKETBALL_3_X_3
      case LS_SPORT_ID.FLOOR_BALL:
        return SPORT_ID.FLOORBALL
      case LS_SPORT_ID.SUMO:
        return SPORT_ID.SUMO
      case LS_SPORT_ID.VIRTUAL_SPORTS:
        return SPORT_ID.E_SPORT
      case LS_SPORT_ID.HANDBALL:
        return SPORT_ID.HANDBALL
      case LS_SPORT_ID.POLITICS:
        return UNKNOWN // 벳레이더에 경기 없음
      case LS_SPORT_ID.WEATHER:
        return UNKNOWN // 벳레이더에 경기 없음
      case LS_SPORT_ID.TV_GAMES:
        return SPORT_ID.E_SPORT
      case LS_SPORT_ID.LOTTERY:
        return SPORT_ID.WORLD_LOTTERY
      case LS_SPORT_ID.BOWLS:
        return SPORT_ID.BOWLS
      case LS_SPORT_ID.POKER:
        return UNKNOWN // 벳레이더에 경기 없음
      case LS_SPORT_ID.WATER_POLO:
        return SPORT_ID.WATERPOLO
      case LS_SPORT_ID.ALPINE_SKIING:
        return SPORT_ID.ALPINE_SKIING
      case LS_SPORT_ID.SAILING:
        return SPORT_ID.SAILING
      case LS_SPORT_ID.HURLING:
        return SPORT_ID.GAELIC_HURLING
      case LS_SPORT_ID.SKI_JUMPING:
        return SPORT_ID.SKI_JUMPING
      case LS_SPORT_ID.INDY:
        return SPORT_ID.INDY_RACING
      case LS_SPORT_ID.LACROSSE:
        return SPORT_ID.LACROSSE
      case LS_SPORT_ID.BANDY:
        return SPORT_ID.BANDY
      case LS_SPORT_ID.MOTOR_SPORTS:
        return SPORT_ID.MOTORSPORT
      case LS_SPORT_ID.BASEBALL:
        return SPORT_ID.BASEBALL
      case LS_SPORT_ID.RUGBY_UNION:
        return SPORT_ID.RUGBY
      case LS_SPORT_ID.RUGBY_LEAGUE:
        return SPORT_ID.RUGBY_LEAGUE
      case LS_SPORT_ID.CURLING:
        return SPORT_ID.CURLING
      case LS_SPORT_ID.BOXING:
        return SPORT_ID.BOXING
      case LS_SPORT_ID.DARTS:
        return SPORT_ID.DARTS
      case LS_SPORT_ID.TENNIS:
        return SPORT_ID.TENNIS
      case LS_SPORT_ID.AMERICAN_FOOTBALL:
        return SPORT_ID.AMERICAN_FOOTBALL
      case LS_SPORT_ID.SNOOKER:
        return SPORT_ID.SNOOKER
      default:
        return UNKNOWN
    }
  }

  static jobTypeToText(job: number): string {
    switch (job) {
      case JOB_TYPE.BETTOR:
        return '베터'
      case JOB_TYPE.ODDSMAKER:
        return '오즈메이커'
      default:
        return '아직없음'
    }
  }

  static cheerForTeamContentsTypeToAttachmentType(type: CHEER_FOR_TEAM_CONTENTS_TYPE): ATTACHMENT_TYPE {
    if (type === CHEER_FOR_TEAM_CONTENTS_TYPE.AUTO_GENERATE_BET_HISTORY) {
      return ATTACHMENT_TYPE.BET_HISTORY
    }
    return type as unknown as ATTACHMENT_TYPE
  }

  static soccerDisciplinaryText(cardType: string): string {
    switch (cardType) {
      case TIMELINE_SOCCER_DISCIPLINARY_TYPE.YELLOW:
        return '옐로 카드'
      case TIMELINE_SOCCER_DISCIPLINARY_TYPE.RED:
        return '레드 카드'
      case TIMELINE_SOCCER_DISCIPLINARY_TYPE.YELLOW_RED:
        return '옐로-레드 카드'
      default:
        return ''
    }
  }
}
